// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ft-0";
export var animationContainer = "_ft-1";
export var modalContent = "_ft-2";
export var orderName = "_ft-3";
export var refundOption = "_ft-4";
export var refundOptionsContainer = "_ft-5";